var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationCompletedTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DEF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60732 25.6541H30.3926L32.655 29.25H7.34497L9.60732 25.6541Z",
    fill: "#43B5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.153 13.1433L13.1516 13.1601L13.1513 13.177C13.1468 13.438 13.1481 13.6336 13.1495 13.849C13.1502 13.9578 13.1509 14.0716 13.151 14.2016C13.151 14.2016 13.151 14.2017 13.151 14.2017L13.151 25.7524C13.151 26.2227 13.1659 26.761 13.3656 27.1816C13.4743 27.4104 13.6412 27.6154 13.8881 27.757C14.1294 27.8955 14.4098 27.9521 14.7135 27.9521C15.0107 27.9521 15.282 27.897 15.5195 27.7689C15.76 27.6391 15.9316 27.4528 16.0553 27.245C16.2737 26.8783 16.3632 26.3982 16.4406 25.9827C16.4438 25.9653 16.447 25.9481 16.4502 25.931C16.4502 25.9309 16.4502 25.9309 16.4502 25.9308L16.4664 25.8444L16.4665 25.8444L16.4677 25.8374L17.9532 17.2252L20.2073 16.6175L19.857 22.022C19.8525 22.0761 19.8478 22.1295 19.8431 22.1834L19.8421 22.1942C19.8271 22.3643 19.811 22.5467 19.809 22.7167C19.807 22.8897 19.8186 23.0845 19.8768 23.2728C19.9383 23.4714 20.052 23.6625 20.2443 23.8102C20.43 23.9528 20.6536 24.0278 20.892 24.0623C21.3898 24.1344 21.825 24.0432 22.1393 23.6844C22.3966 23.3907 22.5115 22.9692 22.6048 22.6128L22.605 22.612L24.9476 13.5992C25.4245 15.0061 26.7561 16.0186 28.3242 16.0186C30.2928 16.0186 31.8887 14.4227 31.8887 12.4541C31.8887 10.4854 30.2928 8.88954 28.3242 8.88954C26.7533 8.88954 25.4197 9.90572 24.945 11.3166C24.3432 9.44751 22.3726 8.36188 20.4563 8.87845L15.8509 10.1199C14.8385 10.3928 14.0372 11.0608 13.5693 11.9116C13.3689 12.276 13.1923 12.6804 13.153 13.1433Z",
    fill: "#43B5F8",
    stroke: "#DEF3FF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCompletedTasks);
export default __webpack_public_path__ + "static/media/notification-completed-tasks.521874cc869003f8c3f5acb5f1211db1.svg";
export { ForwardRef as ReactComponent };